module.exports = __webpack_public_path__ + "img/11.e94f81e8.png";